import DataRoomNodePreview from './DataRoomNodePreview.component';

export default DataRoomNodePreview;
